import React from "react";
import { cn } from "@/lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { PROV, PROV_OPTIONS } from "@/lib/rates";
import { longDate } from "@/lib/sk";

/** Status pill with the full provenance on hover: source, valid from, whether the interpretation was checked. */
export function ProvenanceBadge({ prov, className, testId, editable, onChange }) {
  const p = prov || {};
  const meta = PROV[p.status] || PROV.uavklart;
  const body = (
    <div className="space-y-1 text-[11.5px]">
      <div className="font-semibold">{meta.label}</div>
      {p.source ? <div><span className="text-muted-foreground">Kilde:</span> {p.source}</div> : null}
      {p.valid_from ? <div><span className="text-muted-foreground">Gyldig fra:</span> {longDate(p.valid_from)}</div> : null}
      <div><span className="text-muted-foreground">Tolkning kontrollert:</span> {p.checked ? "ja" : "nei"}</div>
      {p.note ? <div className="text-muted-foreground">{p.note}</div> : null}
    </div>
  );
  if (editable) {
    return (
      <select value={p.status || "uavklart"} onChange={(e) => onChange({ ...p, status: e.target.value })} className={cn("v-badge h-6 cursor-pointer appearance-none border-0 pr-1 outline-none", meta.cls, className)} data-testid={testId} title={p.source || ""}>
        {PROV_OPTIONS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
    );
  }
  return (
    <Tooltip>
      <TooltipTrigger asChild><span className={cn("v-badge cursor-help", meta.cls, className)} data-testid={testId}>{meta.label}</span></TooltipTrigger>
      <TooltipContent side="top" className="max-w-[320px] rounded-lg border-black/[0.08] bg-white px-3 py-2 text-foreground shadow-float">{body}</TooltipContent>
    </Tooltip>
  );
}

export function SourceLine({ prov, className }) {
  const p = prov || {};
  if (!p.source && !p.valid_from) return null;
  return <div className={cn("truncate text-[11px] text-muted-foreground", className)} title={`${p.source || ""}${p.note ? ` · ${p.note}` : ""}`}>{p.source}{p.valid_from ? ` · fra ${longDate(p.valid_from)}` : ""}{p.checked === false ? " · tolkning ikke kontrollert" : ""}</div>;
}
